var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-button',{class:_vm.bootstrapClass,attrs:{"route":_vm.route,"text":_vm.text,"title":_vm.title,"fa-class":_vm.faClass,"fa-position":_vm.faPosition}})}
var staticRenderFns = []

export { render, staticRenderFns }